import { Stack, Typography } from '@mui/material';
import { Link } from '@engyalo/design-system';
import { useTranslation } from 'react-i18next';
import {
  ANDROID_NOTIFICATIONS_SETTINGS_URL,
  IOS_NOTIFICATIONS_SETTINGS_URL,
  NOTIFICATION_PERMISSION,
} from 'constants/notifications';
import DialogConfirmation from 'components/DialogConfirmation';
import { STORAGE_KEYS } from 'constants/defaultValues';
import { INotificationPermissionModal } from './types';

const NotificationPermissionModal = ({ open, handleClose }: INotificationPermissionModal) => {
  const isDenied = Notification.permission === NOTIFICATION_PERMISSION.DENIED;
  const { t } = useTranslation();

  const handleCancelPermission = () => {
    localStorage.setItem(STORAGE_KEYS.PERMISSION_DENIED, Date.now().toString());
    handleClose();
  };

  const handleAcceptPermission = async () => {
    const permission = await Notification.requestPermission();
    if (permission === NOTIFICATION_PERMISSION.DENIED) {
      localStorage.setItem(STORAGE_KEYS.PERMISSION_DENIED, Date.now().toString());
    }
    handleClose();
  };

  const description = isDenied ? (
    <Stack gap={1} alignItems="center">
      <Typography variant="body1">{t('notificationsDeniedMobile')}</Typography>
      <Stack direction="row" spacing={1}>
        <Link href={IOS_NOTIFICATIONS_SETTINGS_URL} target="_blank" rel="noopener noreferrer">
          iOS
        </Link>
        <Typography variant="body1">|</Typography>
        <Link href={ANDROID_NOTIFICATIONS_SETTINGS_URL} target="_blank" rel="noopener noreferrer">
          Android
        </Link>
      </Stack>
    </Stack>
  ) : (
    'notificationsDescription'
  );
  return (
    <DialogConfirmation
      open={open}
      onCancel={handleCancelPermission}
      cancelLabel={t('closeModal')}
      onConfirm={isDenied ? undefined : handleAcceptPermission}
      title={t('notificationsTitle')}
      description={description}
    />
  );
};

export default NotificationPermissionModal;
